import React, { useEffect, useState, useCallback } from "react";
import { usePolling } from "../../composables/usePolling.js";
import { Card, CardBody } from "./../../components/card/card.jsx";
import { aiChatPDF, asset, machineProfile } from "../../api/index.js";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/AuthContext.jsx";
import {
  formatDateOnly,
  printLocation,
} from "../../utils/helper.jsx";
import { useDashboardContext } from "../../contexts/NewDashboardContext.jsx";
import ConfirmationDlg from "../../components/ConfirmationDlg/index.jsx";
import DataTable from "react-data-table-component";
import NormalSelect from "../../components/form/HorizontalNormalSelect";

function AssetList() {
  const { locations, selectedApp } = useDashboardContext();
  const { getLocationName } = useAuth();
  const [file, setFile] = useState(undefined);
  const [showAddDoc, setshowAddDoc] = useState(false);
  const [locationValue, setLocationValue] = useState([]);
  const [sublocations, setSublocations] = useState([]);
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState({ page: 1, take: 10, totalData: 1 });
  const [assets, setAssets] = useState([]);
  const [deleteRow, setDeleteRow] = useState(null);
  const [progressMsgRow, setProgressMsgRow] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [dataToSend, setDataToSend] = useState({
    asset_id: "",
    machine_id: "",
  });
  useEffect(() => {
    let sublocations = locations;
    const copy = [sublocations];

    const findSublocation = (lv, index) => {
      const location = sublocations.find((l) => l.id == lv);

      if (
        location &&
        location.sublocations &&
        location.sublocations.length > 0
      ) {
        copy.splice(index + 1);
        copy.push(location.sublocations);
        sublocations = location.sublocations;
      } else {
        copy.splice(index + 1);
      }
    };

    if (locationValue.length > 0) {
      locationValue.forEach((lv, index) => {
        findSublocation(lv, index);
      });
      setSublocations(copy);
    }
  }, [locationValue]);
  useEffect(() => {
    if (locationValue.length > 0) {
      const location_id = locationValue[locationValue.length - 1];
      if (selectedApp === "CMMS") {
        getAsset(location_id);
      } else {
        getMachine(location_id);
      }
    }
  }, [locationValue]);
  const getAsset = async (location_id) => {
    const res = await asset.list({ location_id });
    if (res.ok) {
      const body = await res.json();
      let data = body.data;
      if (data) {
        data.map((d) => {
          d["component"] = d.asset_components;
          d["name"] = d.asset_name;
          d["value"] = d.id;
        });
        setAssets(data);
      }
    }
  };
  const getMachine = async (location_id) => {
    const res = await machineProfile.list({ location_id });
    if (res.ok) {
      const body = await res.json();
      let data = body.data;
      if (data) {
        data.map((d) => {
          d["component"] = d.machine_components;
          d["name"] = d.machine_name;
          d["value"] = d.id;
        });
        setAssets(data);
      }
    }
  };
  const handleLocationChange = (e, index) => {
    const location_values = [...locationValue];
    location_values.splice(index);
    location_values.push(e.target.value);
    console.log(location_values);
    setLocationValue(location_values);
  };
  const getData = useCallback(async () => {
    try {
      setLoading(true);
      const queryParam = {
        ...query,
      };
      const res = await aiChatPDF.list(queryParam);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data && data.data?.docs) {
          console.log(data.data.docs);
          setDatas(data.data.docs);
        }
        setQuery((prev) => ({
          ...prev,
          totalData: data?.data?.total,
        }));
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }, [query]);

  // Polling hook - refresh data every 15 seconds
  usePolling(getData, 15000, true, [query.page, query.take, query.location_id, query.category_id]);

  function deleteDocument(id) {
    aiChatPDF
      .delete(id)
      .then((res) => {
        if (res.ok) {
          toast.success("Document deleted successfully");
          getData();
        } else {
          toast.error("Failed to delete document");
        }
      })
      .catch((err) => {
        toast.error(err.message);
      })
      .finally(() => {
        hideConfirmationDialog();
      });
  }

  function showProgressMsgDlg(row) {
    setProgressMsgRow(row);
  }

  function showConfirmationDlg(row) {
    setDeleteRow(row);
  }

  function hideConfirmationDialog() {
    setDeleteRow(null);
    setProgressMsgRow(null);
  }

  const [downloadingDocs, setDownloadingDocs] = useState(new Set());

  const downloadDoc = async (row) => {
    if (downloadingDocs.has(row.id)) return; // Prevent multiple downloads
    
    try {
      setDownloadingDocs(prev => new Set(prev).add(row.id));
      
      // Show loading toast
      const loadingToast = toast.loading('Preparing download...');
      
      const response = await aiChatPDF.downloadDocs(row.id);
      const data = await response.json();
      
      // Dismiss loading toast
      toast.dismiss(loadingToast);
      
      const code = data?.data?.code
      const url = data?.data?.data?.url
      if (code === 0 && url) {
        // Create a temporary link to trigger download from the signed URL
        const link = document.createElement('a');
        link.href = url;
        link.download = row.name || 'document';
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        toast.success('Download started!');
      } else {
        toast.error('Failed to get download URL');
      }
    } catch (error) {
      console.error('Download error:', error);
      toast.error('Failed to download document');
    } finally {
      setDownloadingDocs(prev => {
        const newSet = new Set(prev);
        newSet.delete(row.id);
        return newSet;
      });
    }
  }


  const columns = [
    {
      name: "Doc Name",
      selector: (row) => row.name,
      wrap: true,
      minWidth: "150px",
    },
    {
      name: "Added By",
      selector: (row) => row.added_by,
      wrap: true,
      minWidth: "150px",
    },
    {
      name: "Upload Time",
      minWidth: "120px",
      maxWidth: "120px",
      selector: (row) => formatDateOnly(row.create_date),
    },
    {
      name: "Data Process Status",
      minWidth: "130px",
      maxWidth: "130px",
      selector: (row) => row.run,
    },
    {
      name: "Action",
      minWidth: "150px",
      selector: (row) => (
        <div className="btn-group" role="group">
          <button
            onClick={() => showProgressMsgDlg(row)}
            type="button"
            className="btn btn-outline-warning btn-sm"
            style={{ marginRight: "5px" }}
            disabled={downloadingDocs.has(row.id)}
            title="View Upload Progress"
          >
            <i className="bi bi-arrow-repeat"></i>
          </button>
          <button
            onClick={() => downloadDoc(row)}
            type="button"
            className="btn btn-outline-theme btn-sm"
            style={{ marginRight: "5px" }}
            disabled={downloadingDocs.has(row.id)}
            title="Download Document"
          >
            <i className={`bi ${downloadingDocs.has(row.id) ? 'bi-hourglass-split' : 'bi-download'}`}></i> 
          </button>
          <button
            onClick={() => showConfirmationDlg(row)}
            type="button"
            className="btn btn-outline-danger btn-sm"
            disabled={downloadingDocs.has(row.id)}
            title="Delete Document"
          >
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ),
    },
  ];

  const handleChangeLocationFilter = (location_id) => {
    setQuery((prev) => ({
      ...prev,
      page: 1,
      location_id: location_id ? location_id : "",
    }));
  };

  const handleChangeCategory = (id) => {
    setQuery((prev) => ({
      ...prev,
      page: 1,
      category_id: id,
    }));
  };

  // Initial data load - polling hook will handle subsequent refreshes
  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    console.log({ locations });
    if (locations) setSublocations([locations]);
  }, [locations]);
  const addAssetProcess = async () => {
    setSubmitLoading(true);
    if (selectedApp === "CGM" && !dataToSend.machine_id) {
      toast.error("Please select a machine");
      return;
    }
    if (selectedApp === "CMMS" && !dataToSend.asset_id) {
      toast.error("Please select an asset");
      return;
    }
    if (!file) {
      toast.error("Please select a file to upload");
      return;
    }
    const res = await aiChatPDF.upload(dataToSend, file);
    if (res.ok) {
      const body = await res.json();
      toast.success("Document added successfully");
      setshowAddDoc(false);
      setFile(undefined);
      setDataToSend({ asset_id: "" });
      getData();
      setSubmitLoading(false);
    } else {
      setSubmitLoading(false);
      const body = await res.json();
      toast.error(body.message || "Failed to add document");
    }
  };
  const handleOnchangeAsset = (e) => {
    let key = e.target.name;

    setDataToSend((prevData) => ({
      ...prevData,
      [key]: e.target.value,
    }));
  };
  const handleChangeFile = async (e) => {
    //console.log("on select file");
    if (!e.target.files || e.target.files.length === 0) {
      setFile(undefined);
      return;
    }
    setFile(e.target.files[0]);
  };
  return (
    <div className="container">
      <ConfirmationDlg
        open={showAddDoc}
        onClose={() => setshowAddDoc(false)}
        btnSubmitText={"Add Document"}
        btnCancelText={"Cancel"}
        onSubmit={addAssetProcess}
        loading={submitLoading}
      >
        {sublocations.map((sublocation, index) => {
          return (
            <NormalSelect
              key={index}
              required={true}
              value={locationValue[index]}
              label={getLocationName(index)}
              onchange={(e) => handleLocationChange(e, index)}
              list={sublocation}
              name={`location_id`}
              valueKey={"id"}
              textKey="location_name"
              renderFn={printLocation}
            />
          );
        })}
        {selectedApp === "CMMS" ? (
          <NormalSelect
            label={"Asset"}
            onchange={handleOnchangeAsset}
            value={dataToSend["asset_id"]}
            name={"asset_id"}
            id="asset"
            className="form-select"
            required
            list={assets}
            valueKey={"id"}
          />
        ) : (
          <NormalSelect
            label={"Machine"}
            onchange={handleOnchangeAsset}
            value={dataToSend["machine_id"]}
            name={"machine_id"}
            id="machine"
            className="form-select"
            required
            list={assets}
            valueKey={"id"}
          />
        )}

        <div className="position-relative">
          <label
            htmlFor="files"
            className={"border-theme border-1 border w-100"}
            style={{ height: "150px", cursor: "pointer" }}
          >
            <div
              style={{
                cursor: "pointer",
                position: "absolute",
                top: "0",
                left: "50%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                minHeight: "150px",
                alignItems: "center",
                transform: "translateX(-50%)",
              }}
            >
              {file ? (
                <div>
                  <p className="text-muted mb-0">Selected File: {file.name}</p>
                  <p className="text-muted mb-0">
                    Size: {(file.size / 1024).toFixed(2)} KB
                  </p>
                </div>
              ) : (
                <div style={{ textAlign: "center" }}>
                  <i
                    className="fa fa-file-archive"
                    style={{ fontSize: "25px" }}
                  ></i>
                  Choose PDF Document
                </div>
              )}
            </div>
          </label>
          <input
            id="files"
            onChange={handleChangeFile}
            accept=".pdf"
            style={{ visibility: "hidden", position: "absolute" }}
            type="file"
          />
        </div>
      </ConfirmationDlg>

      <ConfirmationDlg
        open={deleteRow != null}
        onClose={hideConfirmationDialog}
        btnSubmitText={"Delete"}
        btnCancelText={"Cancel"}
        onSubmit={() => deleteDocument(deleteRow.id)}
      >
        <div className="text-center">
          <h4 className="mb-3">
            Are you sure you want to delete this document?
          </h4>
          <p className="text-muted">
            This action cannot be undone. Please confirm that you want to delete
            the document titled <strong>{deleteRow?.name}</strong>.
          </p>
        </div>
      </ConfirmationDlg>

      <ConfirmationDlg
        open={progressMsgRow != null}
        onClose={hideConfirmationDialog}
        hideSubmitBtn={true}
      >
        <div className="text-center">
          <h5 className="mb-3">Progress Details</h5>
          <div 
            className="text-muted text-start"
            style={{
              maxHeight: '400px',
              overflowY: 'auto',
              whiteSpace: 'pre-line',
              fontFamily: 'monospace',
              fontSize: '0.9rem',
              lineHeight: '1.4',
              padding: '10px',
              border: '1px solid #dee2e6',
              borderRadius: '4px'
            }}
          >
            {progressMsgRow?.progress_msg}
          </div>
        </div>
      </ConfirmationDlg>
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Document</a>
            </li>
            <li className="breadcrumb-item active">Document List</li>
          </ul>

          <h1 className="page-header">Document List</h1>

          <hr className="mb-4" />

          <div id="datatable" className="mb-5">
            <div className="row mb-2 justify-content-sm-end">
              <div className="col-sm-3 mb-2 mb-sm-0">
                <button
                  onClick={() => {
                    setshowAddDoc(true);
                  }}
                  className="btn btn-outline-theme w-100"
                >
                  Add Document <i className="bi bi-plus"></i>
                </button>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <Card>
                  <CardBody>
                    <DataTable
                      progressPending={loading}
                      pointerOnHover
                      expandOnRowClicked
                      expandableRowsHideExpander
                      highlightOnHover
                      theme="dark"
                      columns={columns}
                      data={datas}
                      pagination
                      paginationServer
                      onChangeRowsPerPage={(row) =>
                        setQuery((prev) => ({ ...prev, page: 1, take: row }))
                      }
                      paginationTotalRows={query.totalData}
                      onChangePage={(page) =>
                        setQuery((prev) => ({ ...prev, page: page }))
                      }
                    />
                  </CardBody>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AssetList;
